import { getItem } from "../services/localStorage.service";

export const isAdmin = () => {
  const accountProfile = getItem("account_profile");
  return accountProfile?.role_id === 1;
};

export const isAdminHealthPlace = () => {
  const accountProfile = getItem("account_profile");
  return accountProfile?.role_id === 2;
};

export const isAdminZone = () => {
  const accountProfile = getItem("account_profile");
  return accountProfile?.role_id === 4;
};

export const isAdminReward = () => {
  const accountProfile = getItem("account_profile");
  return accountProfile?.role_id === 8;
};
